import axios from "@/axios";

export const namespaced = true

export const state = {
    roles: []
}

export const getters = {
        roles: function (state) {
            return state.roles;
        }
}
    
export const mutations = {
        SET_ROLES: (state, resp) => (state.roles = resp.data),
}

export const actions = {
        async getRoles({commit}) {
            commit('SET_ROLES', await axios.get("/api/roles"))
        }
}
